import { handleFloatingPromise } from "@solvari/utils";

import { initExpertSite } from "./expertSite";

import "./components/accordion.js";
import "./components/sidebarCta.js";

import "../styles/evotis_2.css";

handleFloatingPromise(initExpertSite());
